import NewzzService from './services';
import NewzzTypes from './types';

import type IPagination from 'interfaces/IPagination';

export const list = (pagination?: IPagination) => NewzzTypes.listNewzz.createAction(() => NewzzService.list(pagination));
export const loadById = (id: number) => NewzzTypes.loadNewzz.createAction(() => NewzzService.loadById(id));
export const clickNewzz = (id: any) => NewzzTypes.clickNewzz.createAction(() => NewzzService.clickNewzz(id));
